export default {
	computed:
		{
			$breadcrumb (): Array<any> {
				const router = (this as any).$router as any;
				const route = (this as any).$route as any;
				const home = ((router.options || {}).routes || []).find((item: any) => item.path == '/');
				if (!route.path || !route.matched) {
					return [];
				}
				const matched = route.path == '/' ? [ home ] : [ home, ...route.matched ];
				return matched
					.map(item => {
						if (item.meta && item.meta.title) {
							return {
								path: item.path,
								title: item.meta.title,
							};
						}
						return null;
					})
					.filter(item => !!item);
			},
			$menu (): Array<any> {
				const router = (this as any).$router as any;
				const getList = (aryData: Array<any>): any => {
					return aryData
						.map(item => {
							if (item.meta && item.meta.role) {
								return {
									guid: item.meta.guid,
									parentid: item.meta.parentid,
									icon: item.meta.icon || '',
									title: item.meta.title,
									path: item.path,
									children: getList(item.children || []),
								};
							}
							return null;
						})
						.filter(item => !!item);
				};
				return getList((router.options || {}).routes || []);
			},
			$menuDict (): any {
				const router = (this as any).$router as any;
				const loopList = (aryData: Array<any>, dict: any): any => {
					aryData.forEach(item => {
						if (item.meta && item.meta.guid) {
							dict[item.meta.guid] = item;
						}
						loopList(item.children || [], dict);
					});
					return dict;
				};
				return loopList((router.options || {}).routes || [], {});
			},
		},
	methods:
		{
			$getNavPath (guid: string, join: boolean = true): string | Array<any> {
				const menuDict = (this as any).$menuDict;
				let pathNode: Array<any> = [];

				while (guid && menuDict[guid]) {
					pathNode.unshift(menuDict[guid]);
					guid = menuDict[guid].meta.parentid;
				}

				if (join) {
					return pathNode.map(item => item.path).join('/');
				}
				return pathNode;
			},
		},
};
